import React, { useEffect, useState } from 'react';
import { host_url } from '../../../App';
import '../../../styles/CiTable.css';
import './Pabrika.css';
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente

function PabrikaAuslesen() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    fetch(`${host_url}/pabrika`)
      .then(response => response.json())
      .then(data => setEntries(data))
      .catch(error => console.error('Error fetching Pabrika entries:', error));
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/parlament" />
        <h1>Pabrika-Anträge</h1>
      </div>
      <div className="table-header">
        <span className="print-link no-print" onClick={handlePrint}>
          <span className="material-symbols-outlined">print</span>
          <span className="print-text">Drucken</span>
        </span>
      </div>
      <div className="ci-table-wrapper">
        <table className="ci-table pabrika-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Antrag</th>
              <th>Zelt/Bereich</th>
              <th>Bearbeitet</th>
            </tr>
          </thead>
          <tbody>
          {entries.map(entry => (
              <tr key={entry.ID}>
                <td>{entry.Name}</td>
                <td>{entry.Antrag}</td>
                <td>{entry['Zelt/Bereich']}</td>
                <td>{entry.bearbeitet ? 'Ja' : 'Nein'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
    </div>
  );
}

export default PabrikaAuslesen;
